import StateManager from 'Apollo/StateManager';
import { Media, ShowroomMobileMenuType, ShowroomPdf, ShowroomTab, ShowroomUserViewUi } from 'generated/graphql';

import { RequiredFields } from 'Types/RequiredFields';

const stateManager = new StateManager<ShowroomUserViewUi>('showroom.userView');

export const setShowroomSelectedMedia = (selectedMedias: RequiredFields<Media, 'cloudinaryId' | 'mediaType'>[]) => {
	stateManager.update({ selectedMedias } as any);
};

export const setSelectedPdfs = (selectedPdfs: ShowroomPdf[]) => {
	stateManager.update({ selectedPdfs });
};

export const setShowroomSelectedTab = (tab: ShowroomTab) => {
	const { selectedTab } = stateManager.get();
	stateManager.update({ selectedTab: tab === selectedTab ? null : tab });
};

export const openMediaMobileMenu = (mediaId: string, type: ShowroomMobileMenuType) => {
	stateManager.update({ activeMediaMobileMenu: { mediaId, type } });
};

export const closeCurrentMediaMobileMenu = () => {
	stateManager.update({ activeMediaMobileMenu: null });
};
